<template>
  <div>
    <b-container>
      <div class="mt-4 d-flex align-items-start justify-content-between">
        <div>
          <h1 class="page-title">{{ $t('Clients') }}</h1>
          <h2 class="page-subtitle">{{ $t('Total') }} : {{ totalCount }}</h2>
        </div>
        <b-button variant="primary" @click="clickOnCreateBtn">
          <plus-icon size="18" class="mr-1"/>
          {{ $t('Add') }} {{ $tc('client') }}
        </b-button>
      </div>

      <b-card class="mt-2 mb-4 shadow-sm">

        <b122-table
            ref="B122TableClient"
            identifier="B122TableClient"
            init-b122-table-url="/client/initB122Table"
            get-b122-table-results-url="/client/getB122TableResults"
            :fields="tableFields"
            @setTotalCount="setTotalCount"
            @clickOnShowBtn="clickOnShowBtn"
            @clickOnEditBtn="clickOnEditBtn"
            @clickOnDeleteBtn="clickOnDeleteBtn"
        >
        </b122-table>
      </b-card>
    </b-container>
    <Client-delete-modal :selectedClient="ui.selectedClient" @didDeleteClient="didDeleteClient()"></Client-delete-modal>
  </div>
</template>

<script>

import B122Table from "../../components/b122/B122Table";
import ClientDeleteModal from "./ClientDeleteModal";
import {mapActions} from "vuex";
import {dateUtils} from "@/mixins/utils";

export default {

  name: 'ClientIndex',

  components: {
    B122Table,
    ClientDeleteModal
  },

  data() {
    return {
      totalCount: 0,

      tableFields: [
        {
          label: "",
          key: "show",
          sortable: false
        },
        {
          label: this.$i18n.t('client.LastName'),
          key: "name",
          sortable: true,
          sortKey: "firstName"
        },
        {
          label: this.$i18n.t('client.Agency'),
          key: "agencyName",
          sortable: true
        },
        {
          label: this.$i18n.t('agency.Phone'),
          key: "phone",
        },
        {
          label: this.$i18n.t('client.Email'),
          key: "email",
          sortable: true
        },
        {
          label: "",
          key: "actions"
        }
      ],
      ui: {
        selectedClient: null
      }
    }
  },

  methods: {

    setTotalCount(totalCount) {
      this.totalCount = totalCount
    },

    clickOnCreateBtn() {
      this.$router.push({
        name: 'ClientCreate'
      })
    },

    clickOnShowBtn(row) {
      this.$router.push({
        name: 'ClientShow',
        params: {
          clientId: row.item.id
        }
      })
    },

    clickOnEditBtn(row) {
      this.$router.push({
        name: 'ClientEdit',
        params: {
          clientId: row.item.id
        }
      })
    },

    clickOnDeleteBtn(row) {
      this.ui.selectedClient = row.item
      this.$bvModal.show('client-delete-modal')
    },

    didDeleteClient() {
      this.ui.selectedClient = null;
      this.$refs.B122TableClient.refreshTable()
    },

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/client/ClientIndex.vue